const transform = (value, isNegative) =>
  `${value * (isNegative ? -0.25 : 0.25)}rem`;

export default (value, isNegative) =>
  Array.isArray(value)
    ? `${transform(value[1], isNegative)} ${transform(value[0], isNegative)}`
    : transform(value, isNegative);
